import { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';

import RichText from '../../../../Core/RichText';
import CurrencyFormatter from '../../../../Core/CurrencyFormatter';
import ToolTip from '../../../../Core/ToolTip';

import {
  SummaryContainer,
  ButtonContainer,
  Button,
  PointsContainer,
  Points,
  PointsBlock,
  PointsWrapper,
  EstimatedPoints,
  EstimatedWorth,
  EstimatedWorthText,
  StyledImage,
  StyledCtas,
} from './styles';

const roundToNearestTens = value => {
  if (value < 10000) return 0;
  const ptsDeduction = value / 1000;
  return Math.floor(ptsDeduction / 10) * 10;
};

const CalculatorSummary = ({ data }) => {
  if (!data) return null;

  const intl = useIntl();

  const {
    banking,
    spending,
    products,
    productLists,
    pointsText,
    worthText,
    pointsSubtext,
    ctas,
  } = data;

  const [dateTime, setDateTime] = useState('12');

  const ptsAdded = (banking + spending) * parseInt(dateTime, 10);
  const pointsTotal = roundToNearestTens(ptsAdded);

  const handleButtonClick = e => {
    window.dataLayer = window.dataLayer || [];
    const gtmData = {
      event: 'pco calculator engagement', // cta click event name
      action: e.target.value === '1' ? 'monthly view' : 'yearly view',
    };
    window.dataLayer.push(gtmData);
    setDateTime(e.target.value);
  };

  return (
    <SummaryContainer>
      <ButtonContainer>
        <Button
          type="button"
          value="1"
          onClick={handleButtonClick}
          className={`${dateTime === '1' ? 'active' : 'inactive'}`}
        >
          {intl.formatMessage({
            id: 'monthly',
          })}
        </Button>
        <Button
          type="button"
          value="12"
          onClick={handleButtonClick}
          className={`${dateTime === '12' ? 'active' : 'inactive'}`}
        >
          {intl.formatMessage({
            id: 'yearly',
          })}
        </Button>
      </ButtonContainer>
      <PointsContainer className="points-breakdown">
        {productLists.map(prodName => {
          return (
            <PointsBlock key={prodName.id}>
              <PointsWrapper>
                <RichText document={prodName.text} />
                <Points>{prodName.estimatedValue} points</Points>
              </PointsWrapper>
            </PointsBlock>
          );
        })}
      </PointsContainer>
      <PointsContainer>
        <PointsBlock>
          <PointsWrapper>
            <p>{pointsText}</p>
            <EstimatedPoints>{ptsAdded}</EstimatedPoints>
          </PointsWrapper>
        </PointsBlock>
      </PointsContainer>
      <PointsContainer>
        <PointsBlock>
          <PointsWrapper>
            <EstimatedWorthText>
              {worthText}
              <ToolTip
                tipData={pointsSubtext}
                labelId="worth"
                ariaLabel={pointsSubtext}
              >
                ?
              </ToolTip>
            </EstimatedWorthText>
            <EstimatedWorth>
              <CurrencyFormatter
                value={pointsTotal >= 0 ? pointsTotal : 0}
                lang={intl.locale}
              />
            </EstimatedWorth>
          </PointsWrapper>
        </PointsBlock>
      </PointsContainer>
      {products[0].imageDam && (
        <StyledImage src={products[0].imageDam} alt="" />
      )}
      {ctas && <StyledCtas ctas={ctas} />}
    </SummaryContainer>
  );
};

CalculatorSummary.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CalculatorSummary;
